var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Select, SelectOption, SelectVariant } from '@patternfly/react-core';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import TextFilter, { isFilterValue } from './TextFilter';
var CheckboxFilter = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.value, value = _c === void 0 ? [] : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { return undefined; } : _d, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, props = __rest(_a, ["items", "value", "onChange", "isDisabled"]);
    var placeholder = props.placeholder, className = props.className;
    var _f = useState(false), isExpanded = _f[0], setExpanded = _f[1];
    var _g = useState([]), selected = _g[0], setSelected = _g[1];
    var prevSelected = useRef(selected);
    var changeSelected = function (value) {
        prevSelected.current = selected;
        setSelected(value);
    };
    useEffect(function () {
        !isEqual(prevSelected.current, value) && value && changeSelected(value);
    }, [selected, value]);
    var calculateSelected = function () {
        return Array.from(new Set(__spreadArray(__spreadArray([], (value && value.length > 0 && value.constructor === Array
            ? value.map(function (item) {
                return isFilterValue(item) ? item.value : item;
            })
            : []), true), selected, true)));
    };
    var onSelect = function (event, selection) {
        var newSelection = calculateSelected();
        newSelection = newSelection.includes(selection) ? newSelection.filter(function (item) { return item !== selection; }) : __spreadArray(__spreadArray([], newSelection, true), [selection], false);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, newSelection, selection);
        changeSelected(newSelection);
    };
    return (React.createElement(Fragment, null, !items || (items && items.length <= 0) ? (React.createElement(TextFilter, __assign({}, props, { onChange: onChange, isDisabled: isDisabled, value: "".concat(calculateSelected()) }))) : (React.createElement(Select, { className: className, variant: SelectVariant.checkbox, "aria-label": "Select Input", onToggle: function (isExpanded) { return setExpanded(isExpanded); }, isDisabled: isDisabled, onSelect: function (event, value) { return onSelect(event, value); }, selections: calculateSelected(), isOpen: isExpanded, placeholderText: placeholder, ouiaId: placeholder }, items.map(function (_a, key) {
        var value = _a.value, onClick = _a.onClick, label = _a.label, id = _a.id, item = __rest(_a, ["value", "onClick", "label", "id"]);
        return (React.createElement(SelectOption, __assign({}, omit(item, 'onChange'), { key: id || key, value: String(value || id || key), onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick(e, __assign({ value: value, label: label, id: id }, item), key); } }), label));
    })))));
};
export default CheckboxFilter;
//# sourceMappingURL=CheckboxFilter.js.map